import clsx from 'clsx'
import { motion, type HTMLMotionProps } from 'motion/react'

type TabControlProps = {
    children: React.ReactNode
    position?: 'left' | 'right' | 'midBottom' | 'leftBottom' | 'topRight'
} & HTMLMotionProps<'div'>

export default function TabControls({
    children,
    position = 'right',
    ...motionProps
}: TabControlProps) {
    return (
        <motion.div
            className={clsx(
                'z-600 absolute pointer-events-auto',
                position === 'left' && 'top-0  left-4 | stele:left-16',
                position === 'right' && 'top-0  right-4 | stele:right-16',
                position === 'midBottom' && 'bottom-0',
                position === 'leftBottom' && 'bottom-0 stele:left-12 left-3',
                position === 'topRight' && 'top-30 right-0 | stele:top-120'
            )}
            {...motionProps}
        >
            <div
                className={clsx(
                    'flex flex-col justify-center items-center bg-white-gradient drop-shadow-tab-controls',
                    'gap-2',
                    position === 'left' && 'rounded-b-full p-1 pt-4',
                    position === 'right' && 'rounded-b-full p-1 pt-4',
                    position === 'midBottom' && 'rounded-t-full  p-1 pb-4',
                    position === 'leftBottom' && 'rounded-t-full  p-1 pb-4 stele:p-4 stele:pb-16',
                    position === 'topRight' && 'rounded-l-full p-1 pr-4 | stele:p-4 stele:pr-16'
                )}
            >
                {children}
            </div>
        </motion.div>
    )
}